import { skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { Paragraph6EEGCreditData } from "../Paragraph6.types";

export function useParagraph6CreditGetData(creditId?: string) {
  return useQuery({
    queryKey: ["paragraph6CreditGetData", { creditId }],
    queryFn: creditId ? () => fetchParagraph6CreditData(creditId) : skipToken
  });
}

async function fetchParagraph6CreditData(creditId: string) {
  const response = await apiWithoutCamelization.get<Paragraph6EEGCreditData>(
    urls.apiWithoutCamelization.paragraph6CreditGetData(creditId)
  );

  return response.data;
}
